/**
 * ShipmentDeadlineChip - Faixa de prazo da remessa (fonte única).
 *
 * Usada no menu lateral do modal (variante "band") e na listagem
 * (variante "compact"). Regra em `getShipmentDeadline`.
 *
 * RELEASE: 2026-10-16 v1.0.0 - Extraído do ShipmentDetailsModal.
 */
import { AlertTriangle, CalendarDays } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ShipmentDeadlineInfo } from '@/lib/shipmentDeadline';

export function ShipmentDeadlineChip({ deadline, variant = 'band', className }: { deadline: ShipmentDeadlineInfo | null; variant?: 'band' | 'compact'; className?: string }) {
  if (!deadline) return variant === 'compact' ? <span className="text-xs text-muted-foreground">—</span> : null;
  const Icon = deadline.tone === 'destructive' ? AlertTriangle : CalendarDays;
  return (
    <div className={cn('flex items-center gap-2 font-semibold',
      variant === 'band' ? 'rounded-lg px-3 py-2 text-xs' : 'inline-flex h-5 gap-1 whitespace-nowrap rounded-full px-2 text-[10px]',
      deadline.tone === 'destructive' && 'bg-destructive/10 text-destructive',
      deadline.tone === 'warning' && 'bg-warning/15 text-warning',
      deadline.tone === 'success' && 'bg-success/10 text-success', className)}>
      <Icon className={variant === 'band' ? 'h-4 w-4 shrink-0' : 'h-3 w-3 shrink-0'} />
      <span>{deadline.text}</span>
    </div>
  );
}
